/**
 * VIVA HUB login brand panel — dotted background with centered logo
 */

import React from 'react'

export default function HubLoginIllustration() {
  return (
    <div
      className="relative flex h-full w-full items-center justify-center overflow-hidden"
      style={{ backgroundColor: 'var(--color-primary-darkGreen)' }}
    >
      <div className="pointer-events-none absolute inset-0 opacity-30" aria-hidden="true">
        <svg className="h-full w-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="hub-login-grid" width="48" height="48" patternUnits="userSpaceOnUse">
              <circle cx="2" cy="2" r="1.5" fill="currentColor" className="text-white/40" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#hub-login-grid)" />
        </svg>
      </div>

      <div className="relative z-10">
        <img
          src="/img/logo/Color-logo-no-background-300x300.png"
          alt="VIVA Psychotherapy"
          className="h-52 w-52 drop-shadow-lg sm:h-60 sm:w-60 lg:h-72 lg:w-72"
        />
      </div>
    </div>
  )
}
